var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('yd-popup',{attrs:{"position":"center","width":"90%","masker-opacity":".9"},model:{value:(_vm.guanzhuqrshow),callback:function ($$v) {_vm.guanzhuqrshow=$$v},expression:"guanzhuqrshow"}},[_c('img',{staticClass:"qrimg",attrs:{"src":require("../assets/images/qrc.jpg")}}),_vm._v(" "),_c('div',{staticClass:"ts"},[_vm._v("长按识别扫码关注公众号")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08b6f25a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Subscribe.vue
// module id = null
// module chunks = 